import styled from 'styled-components';

export const ExpandedCategorySection = styled.div`
  background: #ef4e5e;
  column-gap: 25px;
  height: 80vh;
  margin: auto;
  width: max-content;
  padding: 20px;
  border-radius: 20px;
  display: flex;
  position: absolute;
  top: 1%;
  left: 50%;
  transform: translateX(-50%);
  max-width: 20vw;
  justify-content: center;
  overflow: hidden;

  align-items: flex-end;

  .left1 {
    display: flex;
    flex-direction: column;
    row-gap: 20px;
  }

  .imgContainer {
    mpaddingtop: 10px;
    transform: translateY(100%);

    img {
      width: 280px;
      border-radius: 20px;
    }
  }

  .textSection {
    line-height: 32px;

    h1 {
      color: #ff8a8a;
      font-size: 18px;
      font-weight: 500;
    }

    span {
      display: block;
      max-: 75%;
      padding-bottom: 8px;
      color: #65383c;
      font-size: 22px;
      font-weight: 700;
    }
  }
`;
export const ExpandedCategorySectionSecond = styled.div`
  background: #ffcba4;
  column-gap: 25px;
  height: 80vh;
  margin: auto;
  width: max-content;
  padding: 20px;
  border-radius: 20px;
  // display: flex;
  position: absolute;
  top: 4%;
  left: 50%;
  transform: translateX(-50%);
  max-width: 20vw;
  justify-content: center;
  overflow: hidden;
  align-items: flex-end;

  .imgContainer2 {
    padding-top: 10px;
    transform: translateY(100%);

    img {
      width: 280px;
      border-radius: 20px;
    }
  }

  .textSection2 {
    line-height: 32px;

    h1 {
      color: #80353e;
      font-size: 18px;
      font-weight: 500;
    }

    span {
      display: block;
      max-: 75%;
      padding-bottom: 8px;
      color: #604548;
      font-size: 22px;
      font-weight: 700;
    }
  }
`;
export const ExpandedCategorySectionThird = styled.div`
  background: #ecf3f4;
  column-gap: 25px;
  height: 80vh;
  margin: auto;
  width: 65%;
  border-radius: 20px;
  display: flex;
  max-width: 60vw;
  flex-direction: column;
  justify-content: flex-start;
  overflow: hidden;
  align-items: flex-end;
  padding: 30px 10px 30px 30px;
  gap: 16px;
  @media (max-width: 720px) {
    width: 100%;
    height: auto;
    max-width: fit-content;
    padding: 16px;
    margin-top: 16px;
  }
  .mobile {
    display: none;
    @media (max-width: 720px) {
      display: inline-block;
    }
  }
  .desktop {
    display: inline-block;
    @media (max-width: 720px) {
      display: none;
    }
  }
`;

export const WrapperNew = styled.div`
  position: relative;
  padding-bottom: 5vh;
`;

export const ExploreBtn = styled.button`
  margin: 0 auto;
  background: #ef4e5e;
  width: 35%;
  border: none;
  padding: 16px 0px;
  margin: 20px auto;
  border-radius: 10px;
  color: rgba(255, 255, 255);
  font-family: 'Montserrat';
  cursor: pointer;
  display: flex;
  justify-content: center;
  @media (max-width: 768px) {
    width: ${(props) => (props.baby ? '100%' : '93%')};
    margin: 0 auto;
    padding: 12px 0px;
  }
  font-size: clamp(14px, 2vw, 22px);
  font-weight: 600;
`;
export const MainCarousel = styled.div`
  overflow-x: scroll;
  overflow-y: hidden;
  &::-webkit-scrollbar {
    display: none;
  }
  width: 57vw;
  padding: 8% 40% 20px;
  display: flex;
  align-items: center;
  justify-content: start;
  column-gap: 50px;
  .carouselCard {
    border-radius: 10px;
    width: 170px;
    img {
      width: 100%;
    }
    flex-shrink: 0;
    transition: all 0.2s linear;
    rotate: 5deg;
    &.active {
      scale: 1.2 !important;
      border-radius: 10px;
      rotate: 0deg !important;
      transform: translateY(0) !important;
    }
  }
`;

export const TopTextSection = styled.div`
  text-align: center;
  padding-top: 20px;
  position: relative;
  margin-top: 5vh;
  .mainHeading {
    color: #604548;
    font-size: 26px;
    font-weight: 800;
    padding: 12px 0 10px;
  }
  .miniHeading {
    color: #80353e;
    font-size: 18px;
    font-weight: 600;
  }
  .message {
    font-size: 16px;
    color: #a47978;
  }
  .rightImg {
    position: absolute;
    width: 100px;
    right: 24%;
    top: -2%;
    opacity: 0;
  }
`;

export const CategorySection = styled.div`
  padding: 30px;
  width: 80vh;
`;

export const ColorBar = styled.div`
  &.toggle {
    flex-basis: 30%;
    @media (max-width: 720px) {
      flex-basis: 40%;
    }

    img {
      opacity: 1 !important;
    }

    p {
      opacity: 0 !important;
    }
  }

  &.toggle2 {
    flex-basis: 30%;
    @media (max-width: 720px) {
      flex-basis: 40%;
    }

    img {
      opacity: 1 !important;
    }

    p {
      opacity: 0 !important;
    }
  }

  position: relative;
  @media (max-width: 720px) {
    flex-basis: 20%;
  }
  flex-basis: 10%;

  height: ${(props) => (props.height ? props.height : '100%')};
  cursor: pointer;
  background: ${(props) => props.background};
  margin-right: 10px;
  border-radius: 2px;
  font-weight: 500;

  img {
    width: 100%;
    opacity: 0;
    height: -webkit-fill-available;
  }

  .blueColor {
    color: #8aa5af;
  }

  .whiteColor {
    color: #fff;
  }

  .setPosition {
    position: absolute;
    top: 50%;
    left: 50%;
    white-space: nowrap;
    transform: translateX(-50%) translateY(-50%) rotate(-90deg);
    opacity: 1;
  }
`;
export const ColorBar2 = styled.div`
  display: flex;
  align-items: end;
  height: 45%;
  .tilt {
    transform: rotate(-4deg);
  }
  .active {
    img {
      opacity: 1;
      transform: scale(3.5);
      transform: translate(55, 0);
    }
  }
  .colorBarInner {
    display: flex;
    flex-basis: 50%;
    height: 100%;
    align-items: end;
  }
`;
export const ColorBarContainer = styled.div`
  display: flex;
  width: 100%;
  height: 45%;
  gap: 10px;
  @media (max-width: 720px) {
    display: inline-block;
  }

  .active {
    img {
      opacity: 1;
      transform: scale(3.5);
      transform: translate(55, 0);
    }
  }
  .bars {
    display: flex;
    align-items: end;
    flex-basis: 50%;
    @media (max-width: 720px) {
      justify-content: center;
      height: 27vh;
    }
  }
  .content {
    flex-basis: 30%;
    @media (max-width: 720px) {
      padding-left: 0px;
      text-align: center;
    }
    padding-left: 20px;
    .madeFor {
      color: #9bbcbf;
      font-weight: 600;
      padding-bottom: 12px;
    }
    .closer {
      color: rgb(86, 117, 120);
      font-weight: 600;
      font-size: clamp(24px, 2vw, 28px);
      padding-bottom: 12px;
    }
    .effectiveScience {
      color: #bfc4c4;
      font-size: clamp(12px, 2vw, 16px);
    }
  }
`;

export const CategoryContainer = styled.div`
  background-color: ${(props) => (props.bgColor ? props.bgColor : '#fcfcf3')};
  width: 60%;
  margin: auto;
  padding: 20px 40px;
  border-radius: 20px;
  margin-bottom: 20px;
  box-shadow: 0 1px 10px -8px rgba(0, 0, 0, 0.7);
  @media (max-width: 768px) {
    width: 100%;
    padding: 20px;
  }
`;

export const TopSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  .brandInfo {
    text-align: center;
    h2 {
      color: #80353e;
      font-size: 22px;
      font-weight: 800;
    }
    p {
      font-size: 16px;
      color: #a47978;
    }
    @media (max-width: 768px) {
      margin-bottom: 20px;
    }
  }
  .brandImg {
    img {
      width: 200px;
    }
    @media (max-width: 768px) {
      display: none;
    }
  }
  @media (max-width: 768px) {
    justify-content: center;
  }
`;

export const StoreHomeGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(
    ${(props) => (props.gridSize ? props.gridSize : 3)},
    1fr
  );
  gap: 10px;

  .cardContainer {
    border-radius: 10px;
    overflow: hidden;
    position: relative;
    padding-top: ${(props) => (props.paddingTop ? props.paddingTop : '30%')};

    span {
      position: unset !important;
    }

    img {
      height: 100% !important;
      object-fit: fill !important;
      border-radius: 10px !important;
    }

    transition: all 0.3s linear;

    .hoverClass {
      display: none;
    }

    &:hover {
      transform: translateY(-10px);
      cursor: pointer;

      &:before {
        opacity: 1;
      }

      .hoverClass {
        display: block;
      }
    }

    &:before {
      display: block;
      opacity: 0;
      content: '';
      width: 100%;
      height: 100%;
      position: absolute;
      inset: 0;
      border-radius: 10px;
      background-color: rgba(0, 0, 0, 0.1);
      z-index: 2;
    }
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(
      ${(props) => (props.mobileGrid ? props.mobileGrid : 2)},
      1fr
    );
  }
`;

export const HoverSection = styled.div``;

export const HoverButtonContainer = styled.div`
  position: absolute;

  top: 5%;
  left: 10%;
  height: max-content;

  .category {
    color: #000;
    font-size: 18px;
    font-weight: 500;
  }

  .products {
    color: #838383;
    font-size: 12px;
  }

  @media (max-width: 768px) {
    left: 5%;
    top: ${(props) => (props.shiftTop ? '25%' : '10%')};
    width: max-content;
    .category {
      color: #000;
      font-size: 14px;
      font-weight: 500;
    }
  }
`;

export const BackArrowContainer = styled.div`
  position: absolute;
  top: 4%;
  transform: rotate(180deg);
  right: ${(props) => (props.second ? '7%' : '11%')};
  background: #fff;
  display: flex;
  align-items: center;
  border-radius: 30px;
  padding: 10px;
`;

export const BrandCategoryContainer = styled.div`
  width: 100%;
  padding: 50px 15% 34px;
  margin: 0 auto 10px;
  background-color: #fff;

  position: relative;
  @media (max-width: 768px) {
    margin-top: 25px;
  }

  .brandSection {
    display: flex;
    align-items: start;
    flex-direction: column;
    row-gap: 20px;
    width: 64%;

    .brandLogo {
      width: 100px;
      @media (max-width: 768px) {
        width: 75px;
      }
    }

    @media (max-width: 768px) {
      width: 100%;
      flex-wrap: wrap;
      row-gap: 20px;
      align-items: baseline;
      justify-content: space-between;
      flex-direction: row;
    }
  }

  .careImgContainer {
    padding-top: 50%;
    width: 42vw;
    position: relative;

    &.mobileImg {
      display: block;
      @media (min-width: 768px) {
        display: none;
      }
    }

    &.desktopImg {
      display: none;
      @media (min-width: 768px) {
        display: block;
      }
    }

    @media (min-width: 768px) {
      padding-top: 26%;
      width: 22vw;
      position: absolute;
      right: calc(15% + 5px);
      top: -1%;
    }
  }

  .brandlogoContainer {
    position: relative;
    padding-top: 22%;
    width: 75px;
    @media (min-width: 768px) {
      width: 110px;
      padding-top: 17%;
    }
  }

  .textSection {
    h2 {
      font-size: clamp(22px, 3vw, 36px);
      padding-bottom: 6px;
      margin: 0;
      color: #5e393c;
    }

    p {
      font-size: clamp(14px, 2vw, 16px);
      margin: 0;
      color: #a1a1a1;
      font-weight: 500;
      @media (min-width: 768px) {
        width: 100%;
        line-height: 26px;
      }
    }
  }

  @media (max-width: 768px) {
    padding: 10px;
  }
`;

export const StaggeredGridSection = styled.div`
  display: flex;
  align-items: flex-start;
  column-gap: 10px;
`;

export const GridColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 33%;
  .offsetTop {
    height: ${(props) => (props.paddingTop ? props.paddingTop : '0')};
  }
  row-gap: 16px;
  @media (max-width: 768px) {
    width: 50%;
  }
`;

export const CategoryCard = styled.div`
  width: 100%;
  position: relative;
  cursor: pointer;
  box-shadow: 1px 1px 4px 0px rgba(78, 78, 78, 0.25);

  .imgContainer {
    position: relative;
    padding-top: 72%;
    overflow: hidden;

    span {
      position: unset !important;
    }

    img {
      height: 100% !important;
      @media (max-width: 768px) {
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
      }
      transition: transform 0.4s;
    }

    @media (min-width: 768px) {
      :hover img {
        transform: scale(1.1);
        transform-origin: 50% 50%;
      }
    }
    @media (max-width: 768px) {
      padding-top: 108%;
    }
  }

  .categoryInfo {
    padding: 12px;
    position: absolute;
    width: 100%;
    left: 0px;
    bottom: 0;
    background-color: #fff;

    p {
      font-size: clamp(14px, 2vw, 16px);
      margin: 0;
      font-weight: 600;
      color: rgb(56, 56, 56);
    }

    span {
      color: #716464;
      font-size: clamp(12px, 2vw, 13px);
      padding-top: 10px;
      padding-left: 2px;
      display: block;
      font-weight: 500;
      opacity: 0.7;
    }

    .arrowFwd {
      rotate: 180deg;
      position: absolute;
      right: 20px;
      top: 20px;
      @media (max-width: 768px) {
        display: none;
      }
    }

    @media (max-width: 768px) {
      border-bottom-right-radius: 10px;
      border-bottom-left-radius: 10px;
      position: unset;
      width: 100%;
      box-shadow: none;
    }
  }

  @media (max-width: 768px) {
    border-radius: 10px;
    box-shadow: 0px 0px 5px -1px rgba(0, 0, 0, 0.25);
  }
`;

export const BlockViewContainer = styled.div`
  border-radius: 24px;
  overflow: hidden;
  background: #fffcf5;
  margin-top: 50px;
  @media (max-width: 720px) {
    padding: 10px 0;
    margin: 0 10px;
    margin-top: 35px;
  }
`;

export const BlockView = styled.div`
  display: grid;
  margin: 20px auto 0;
  padding: 0% 0% 18px;
  border-radius: 20px;
  width: 80vw;
  grid-template-columns: repeat(3, 1fr);
  background: url('https://images.myloapp.in/NestJsUploads/1697714513272-cloud-bg-(1).webp');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  @media (max-width: 720px) {
    background: #fffcf5;
    grid-template-columns: repeat(2, 1fr);
    width: 100%;
    margin-top: 0;
  }
  gap: 10px;
`;

export const CardContainer = styled.div`
  position: relative;
  overflow: ${(props) => (props.showOverflow ? 'unset' : 'hidden')};
  position: relative;
  cursor: pointer;
  padding-top: ${(props) =>
    props.index === 0 ? '0%' : props.index === 3 ? '60%' : '80%'};

  span {
    position: unset !important;
  }

  @media (max-width: 720px) {
    padding-top: ${(props) =>
      props.index === 1 || props.index === 0 ? '0%' : '115%'};
    cursor: none;
  }

  img {
    height: 100% !important;
    object-fit: ${(props) =>
      props.index === 3 ? 'contain' : 'cover'} !important;

    border-radius: 10px !important;
    @media (max-width: 720px) {
      object-fit: contain !important;
    }
    transition: transform 0.4s;
    -webkit-transition: transform 0.4s;
  }

  @media (min-width: 720px) {
    :hover img {
      transform: scale(1.1);
      transform-origin: 50% 50%;
    }
  }
`;

export const BundleOfJoySection = styled.div`
  @media (max-width: 720px) {
    margin-bottom: 10px;
  }

  p {
    color: #604548;
    font-weight: 600;
    @media (min-width: 720px) {
      position: absolute;
      top: 105px;
      width: max-content;
    }
    font-size: clamp(20px, 4vw, 24px);

    &.msg {
      font-size: clamp(14px, 2vw, 16px);
      color: #a1a1a1;
      font-weight: 500;
      line-height: 22px;
      padding-top: 8px;
      @media (min-width: 720px) {
        width: 40vw;
        position: absolute;
        bottom: 45px;
        top: unset;
      }
    }
  }
`;

export const StackCardSection = styled.div`
  .stackImg {
    margin: auto;
    display: flex;
    width: 130px;
  }
  .stackImgContainer {
    position: relative;
    width: 144px;
    padding-top: 30px;
    margin: auto;
  }
  &.hiddenStack {
    @media (max-width: 768px) {
      display: none;
    }
  }
  &.stack1 {
    width: 20vw;
    height: auto;
    // background: #b4b9ba;
    border-top-right-radius: 20px;
    border-top-left-radius: 20px;
    position: relative;
    bottom: ${(props) => (props.bottom ? props.bottom : '-70px')};
    left: 50%;
    transform: translateX(-50%);
    @media (max-width: 768px) {
      width: 78vw;
    }
    padding: 8px;
    // box-shadow: 1px 1px 10px -8px;
    .stackImg {
      width: 150px;
    }
  }
  &.stack2 {
    width: 20vw;
    height: auto;
    // background: #fed79d;
    border-top-right-radius: 20px;
    border-top-left-radius: 20px;
    position: relative;
    bottom: ${(props) => (props.bottom ? props.bottom : '0px')};
    left: 50%;
    transform: translateX(-50%);
    // box-shadow: 1px 1px 10px -8px;
    &.myloBabyContainer {
      position: relative;
      bottom: -40px;
    }
    @media (max-width: 768px) {
      width: 78vw;
    }
    padding: 10px;
    .stackImg {
      width: 120px;
    }
  }
  &.stack3 {
    width: 23vw;
    height: auto;
    // background: #b4b9ba;
    border-top-right-radius: 20px;
    border-top-left-radius: 20px;
    margin: auto;
    margin-top: 30px;
    @media (max-width: 768px) {
      width: 80vw;
    }
  }
  &.stack4 {
    width: 20vw;
    height: auto;
    background: #fff;
    border-top-right-radius: 20px;
    border-top-left-radius: 20px;
    position: relative;
    bottom: 40px;
    margin: auto;
    @media (max-width: 768px) {
      width: 80vw;
    }
    .caretag {
      padding: 12px;
    }
    box-shadow: 1px 1px 10px -8px;
  }

  &.stackOrder2 {
    opacity: 0;
  }
`;

export const StackCardContainer = styled.div`
  min-height: 100px;
  position: relative;
  height: auto;
  width: 100%;
  &.secondStack {
    opacity: 0;
  }
  &.thirdStack {
    opacity: 0;

    margin-bottom: 20px;
  }
`;
